module.exports = __webpack_public_path__ + "media/bowhead-whale.c0122946.mp3";